import { compose, not, equals, defaultTo } from 'ramda';
import { handleActions } from 'redux-actions';

import {
  WATCHLIST_ITEMS_FETCHED,
  WATCHLIST_ITEM_ADDED,
  WATCHLIST_ITEM_REMOVED,
} from 'app/features/watchlist/actionTypes';
import { pickPayload } from 'app/reducers/helpers';

const initialState = [];

const watchlist = handleActions(
  {
    [WATCHLIST_ITEMS_FETCHED]: compose(defaultTo(initialState), pickPayload),
    [WATCHLIST_ITEM_ADDED]: (state, { payload }) => [...state, payload],
    [WATCHLIST_ITEM_REMOVED]: (state, { payload }) =>
      state.filter(compose(not, equals(payload))),
  },
  initialState,
);

export default watchlist;
